import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Files search row placeholder — mirrors `FileCard.web`'s row: a 60x48
 * thumbnail cell, file name, and a short tag/date line underneath.
 */
export const FileRowSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'file-row-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      paddingVertical='xs'
      paddingHorizontal='l'>
      <Skeleton
        variant='rect'
        width={60}
        height={48}
        borderRadius='xs'
        style={{ marginRight: theme.spacing.xs }}
      />
      <Box flex={1} style={{ gap: theme.spacing.xxxs }}>
        <Skeleton variant='text' width='50%' />
        <Skeleton variant='text' width='30%' height={10} />
      </Box>
    </Box>
  );
};
